import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingBagIcon } from 'lucide-react';
type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  children: React.ReactNode;
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
  onLinkClick?: () => void;
  showIcon?: boolean;
};
export function Button({
  children,
  className = '',
  href,
  target,
  rel,
  onLinkClick,
  showIcon = true,
  ...props
}: ButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center gap-2.5 rounded-full bg-ballet-green px-7 py-3.5 text-sm font-bold tracking-[0.01em] text-white shadow-soft transition-colors hover:bg-ballet-greenDark focus:outline-none focus:ring-4 focus:ring-ballet-green/20 sm:px-8 sm:text-base';
  const content = <>
      {showIcon && <ShoppingBagIcon size={18} strokeWidth={2.2} aria-hidden="true" data-id="element-45" />}
      {children}
    </>;
  if (href) {
    return <motion.a href={href} target={target} rel={rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined)} onClick={onLinkClick} className={`${baseClasses} ${className}`} whileHover={{
      y: -2
    }} whileTap={{
      scale: 0.98
    }} data-id="element-46">
        {content}
      </motion.a>;
  }
  return <motion.button className={`${baseClasses} ${className}`} whileHover={{
    y: -2
  }} whileTap={{
    scale: 0.98
  }} {...props} data-id="element-47">
      {content}
    </motion.button>;
}